const media = require('./media');

export class TemplatesSlider {

	constructor(options) {
		this.options = $.extend({
			node: $('.templates__slider'),
			slickOptions: {
				dots: true,
				infinite: false,
				autoplay: true,
				autoplaySpeed: 3000,
				centerMode: true,
				slidesToShow: 1,
				variableWidth: true,
				arrows: false,
				accessibility: false,
				pauseOnFocus: false,
				pauseOnHover: true
			}
		}, options);

		this.slickAdded = false;

		this.sliderAccessibility();

		$(window).resize(() => {
			this.sliderResize();
		});

		this.sliderResize();
	}

	sliderResize() {
		if (media.isTablet()) {
			if (this.options.node.hasClass('slick-slider')) {
				this.options.node.slick('unslick');

				// Очищення для мобільного
				this.options.node.find('.templates__slider-item').attr({
					'tabindex': '0',
					'aria-hidden': 'false'
				});
				this.options.node.find('a, button, input').attr('tabindex', '0');

				// Видаляємо клас активності при переході на мобільний
				this.options.node.find('.slick-slide').removeClass('--is-active');
			}
			this.slickAdded = false;
		} else {
			if (this.slickAdded) {
				this.options.node.slick('resize');
			} else {
				this.options.node.slick(this.options.slickOptions);
			}
			this.slickAdded = true;

			this.options.node.each((i, el) => {
				this.updateAccessibilityState($(el));
			});
		}
	}

	sliderAccessibility() {
		this.options.node.each((index, element) => {
			const $thisSlider = $(element);

			// Зберігаємо стан взаємодії
			$thisSlider.data('is-keyboard', false);

			// --- 1. Визначення типу взаємодії ---

			// Якщо клікнули мишкою або тачнули екран -> Це НЕ клавіатура
			$thisSlider.on('mousedown touchstart', () => {
				$thisSlider.data('is-keyboard', false);
				$thisSlider.find('.slick-slide').removeClass('--is-active');
			});

			// Якщо натиснули будь-яку кнопку -> Це клавіатура
			$thisSlider.on('keydown', (e) => {
				$thisSlider.data('is-keyboard', true);

				if (!$thisSlider.hasClass('slick-initialized')) return;

				const key = e.which || e.keyCode;

				// Стрілка вліво
				if (key === 37) {
					$thisSlider.slick('slickPrev');
				}
				// Стрілка вправо
				else if (key === 39) {
					$thisSlider.slick('slickNext');
				}
				// Enter (13) або Пробіл (32)
				else if (key === 13 || key === 32) {
					const $focusedElement = $(document.activeElement);

					// Перевіряємо, чи фокус стоїть саме на картці слайда
					if ($focusedElement.hasClass('templates__slider-item')) {
						const $link = $focusedElement.find('.templates__slider-link');

						if ($link.length) {
							// Важливо: запобігаємо стандартній поведінці (щоб пробіл не скролив сторінку)
							e.preventDefault();

							const url = $link.attr('href');
							const target = $link.attr('target');

							if (url) {
								// if (target === '_blank') {
								// 	window.open(url, '_blank');
								// } else {
								// 	window.location.href = url;
								// }
								e.preventDefault();
								$link[0].click();
							}
						}
					}
				}
			});

			// --- 2. Події Slick ---

			$thisSlider.on('init reInit afterChange', () => {
				if ($thisSlider.hasClass('slick-initialized')) {
					this.updateAccessibilityState($thisSlider);
				}
			});

			// --- 3. Пауза та Фокус ---

			$thisSlider.on('focusin', () => {
				if ($thisSlider.hasClass('slick-initialized')) {
					$thisSlider.slick('slickPause');
					$thisSlider.addClass('is-focused');
					this.updateAccessibilityState($thisSlider);
				}
			});

			$thisSlider.on('focusout', () => {
				setTimeout(() => {
					if ($thisSlider.hasClass('slick-initialized')) {
						const hasFocusInside = $thisSlider.find(document.activeElement).length > 0;
						if (!hasFocusInside) {
							$thisSlider.slick('slickPlay');
							$thisSlider.removeClass('is-focused');
						}
					}
				}, 10);
			});

			// Initial check
			if ($thisSlider.hasClass('slick-initialized')) {
				this.updateAccessibilityState($thisSlider);
			}
		});
	}

	updateAccessibilityState($sliderInstance) {
		if (!$sliderInstance.hasClass('slick-initialized')) return;

		const $slides = $sliderInstance.find('.slick-slide');
		const $currentSlide = $sliderInstance.find('.slick-current');

		const isKeyboardMode = $sliderInstance.data('is-keyboard');

		// --- Accessibility Attrs ---
		$slides.attr('tabindex', '-1').attr('aria-hidden', 'true');
		$slides.find('a, button, input').attr('tabindex', '-1');

		$currentSlide.attr('tabindex', '0').attr('aria-hidden', 'false');
		$currentSlide.find('a, button, input').attr('tabindex', '0');

		// --- Active Class Logic ---
		$slides.removeClass('--is-active');

		$slides.find('.templates__slider-item').attr('aria-hidden', 'true');
		$currentSlide.find('.templates__slider-item').attr('aria-hidden', 'false');

		if (isKeyboardMode) {
			$currentSlide.addClass('--is-active');
		}
	}
}